import { JsonObject, JsonProperty } from "ta-json";

@JsonObject()
export class TokenInfo {
    @JsonProperty("access_token")
    accessToken: string;

    @JsonProperty("token_type")
    tokenType: string;

    @JsonProperty("refresh_token")
    refreshToken: string;

    @JsonProperty("redirect_url")
    redirectUrl: string;
}
